import { render, staticRenderFns } from "./Check_email_njangi.vue?vue&type=template&id=5b77adc2&scoped=true"
import script from "./Check_email_njangi.vue?vue&type=script&lang=js"
export * from "./Check_email_njangi.vue?vue&type=script&lang=js"
import style0 from "./Check_email_njangi.vue?vue&type=style&index=0&id=5b77adc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77adc2",
  null
  
)

export default component.exports